import type { ReactNode } from "react";

export function ReadOnlyField({
  children,
  label,
}: {
  readonly children: ReactNode;
  readonly label: string;
}) {
  return (
    <div className="flex flex-col gap-1.5">
      <dt className="text-sm font-medium text-text-secondary">{label}</dt>
      <dd className="text-md text-text-primary">{children}</dd>
    </div>
  );
}
